import React from 'react';
import { domainLogo, domainLogoAlt, domainLogoWhite } from './domain-logo';

interface PoweredByAffiliationProps {
  enabled: boolean;
  /** Use white domain logo (dark/gradient backgrounds). Default: color logo. */
  variant?: 'light' | 'dark';
  className?: string;
  align?: 'start' | 'center' | 'end';
}

/**
 * “Powered by” label above the domain logo — matches footer / Mandrill affiliation mark.
 */
export const PoweredByAffiliation: React.FC<PoweredByAffiliationProps> = ({
  enabled,
  variant = 'light',
  className = '',
  align = 'center',
}) => {
  if (!enabled) {
    return null;
  }

  const logo = variant === 'dark' ? domainLogoWhite : domainLogo;
  const labelColor = variant === 'dark' ? 'text-white/80' : 'text-gray-500';
  const alignClass = align === 'start' ? 'items-start' : align === 'end' ? 'items-end' : 'items-center';

  return (
    <div className={`flex flex-col justify-center gap-3 ${alignClass} ${className}`}>
      <span className={`text-md font-['Manrope'] font-thin leading-4 ${labelColor}`}>Powered by</span>
      <img src={logo} alt={domainLogoAlt} className="h-8 w-auto" />
    </div>
  );
};
